// frontend/src/services/subscriptionService.js

import { configuredAxios as api } from './axiosConfig';

/**
 * [FLUXO LIGHTBOX] Envia uma requisição para o backend para obter o paymentId para o modal da Asaas.
 * @param {string} planId - O ID do plano que o usuário está assinando.
 * @returns {Promise<object>} A resposta da API, que deve conter o `paymentId`.
 */
const createSubscription = async (planId) => {
  try {
    const response = await api.post('/subscriptions/create-subscription', { planId });
    return response.data;
  } catch (error) {
    console.error('Erro no serviço ao criar assinatura (Lightbox):', error);
    // O interceptor do Axios já deve formatar o erro, então apenas o relançamos.
    throw error;
  }
};


/**
 * [FLUXO DIRETO] Envia os dados do cartão de crédito para o backend processar a assinatura.
 * @param {string} planId - O ID do plano.
 * @param {string} taxId - O CPF/CNPJ do titular do cartão.
 * @param {object} cardData - Dados do cartão (número, validade, etc.).
 * @param {object} cardHolderData - Dados do titular (endereço, telefone, etc.).
 * @returns {Promise<object>} A resposta de sucesso ou erro do backend.
 */
const createDirectCardSubscription = async (planId, taxId, cardData, cardHolderData) => {
  try {
    const response = await api.post('/subscriptions/create-card-charge', {
      planId,
      taxId,
      cardData,
      cardHolderData
    });
    return response.data; // Deve retornar { success: true, message: '...' }
  } catch (error) {
    console.error('Erro no serviço ao criar assinatura com cartão:', error);
    throw error;
  }
};

/**
 * [FLUXO DIRETO] Envia uma requisição para o backend gerar uma cobrança PIX.
 * @param {string} planId - O ID do plano.
 * @param {string} taxId - O CPF/CNPJ do pagador.
 * @returns {Promise<object>} A resposta da API com os dados do QR Code.
 */
const createDirectPixSubscription = async (planId, taxId) => {
  try {
    const response = await api.post('/subscriptions/create-pix-charge', {
      planId,
      taxId
    });
    return response.data;
  } catch (error) {
    console.error('Erro no serviço ao criar cobrança PIX:', error);
    throw error;
  }
};


/**
 * Obtém os detalhes da assinatura do usuário atualmente logado.
 * @returns {Promise<object>} Os dados da assinatura do usuário.
 */
const getUserSubscription = async () => {
  try {
    const response = await api.get('/subscriptions/me');
    return response.data;
  } catch (error) {
    console.error('Erro no serviço ao buscar assinatura do usuário:', error);
    throw error;
  }
};

/**
 * Envia uma requisição para cancelar a assinatura ativa do usuário.
 * @returns {Promise<object>} A resposta de confirmação do cancelamento.
 */
const cancelSubscription = async () => {
  try {
    const response = await api.patch('/subscriptions/cancel');
    return response.data;
  } catch (error) {
    console.error('Erro no serviço ao cancelar assinatura:', error);
    throw error;
  }
};


const subscriptionService = {
  createSubscription, // Para o Lightbox
  createDirectCardSubscription, // Para o formulário de cartão
  createDirectPixSubscription, // Para o formulário de PIX
  getUserSubscription,
  cancelSubscription
};

export default subscriptionService;